import React from 'react';

// Placeholder vector glyphs for lootbox rewards, keyed by rewardType.
// Each glyph is drawn in a 48×48 box centred at (0,0) so it can be dropped into
// any <svg> (the wheel) via <RewardGlyph type x y size />. Swap a glyph here when
// real artwork is ready — every consumer picks it up.

const Coin = () => (
  <g>
    <circle r="21" fill="#b8860b" />
    <circle r="18" fill="#ffd13a" />
    <circle r="13" fill="none" stroke="#b8860b" strokeWidth="2.5" />
    <path d="M-4 -7 h8 M-4 7 h8 M0 -10 v20" stroke="#8a5a00" strokeWidth="3" strokeLinecap="round" />
  </g>
);

const Gram = () => (
  <g>
    <circle r="21" fill="#0b5c8f" />
    <circle r="18" fill="#2aa8ff" />
    <path d="M-10 -7 L10 -7 L0 11 Z" fill="none" stroke="#fff" strokeWidth="3" strokeLinejoin="round" />
    <path d="M0 -7 V11" stroke="#fff" strokeWidth="2.5" />
  </g>
);

const Module = () => (
  <g>
    <rect x="-17" y="-17" width="34" height="34" rx="7" fill="#6b2fd6" />
    <rect x="-11" y="-11" width="22" height="22" rx="4" fill="#c66cff" />
    <circle cx="-4.5" cy="-2" r="2.6" fill="#1b0b3a" />
    <circle cx="4.5" cy="-2" r="2.6" fill="#1b0b3a" />
    <path d="M-5 5 h10" stroke="#1b0b3a" strokeWidth="2.4" strokeLinecap="round" />
    {[-10, 0, 10].map(p => (
      <g key={p}>
        <rect x={p - 1.5} y="-22" width="3" height="5" fill="#c66cff" />
        <rect x={p - 1.5} y="17" width="3" height="5" fill="#c66cff" />
      </g>
    ))}
  </g>
);

const Mystery = () => (
  <g>
    <rect x="-17" y="-10" width="34" height="27" rx="4" fill="#ff588b" />
    <rect x="-19" y="-17" width="38" height="9" rx="3" fill="#ff7aa3" />
    <rect x="-3" y="-17" width="6" height="34" fill="#ffd13a" />
  </g>
);

const GLYPHS = {
  COINS: Coin,
  TON: Gram,
  CHARACTER_MODULE: Module,
};

export default function RewardGlyph({ type, x = 0, y = 0, size = 48 }) {
  const Glyph = GLYPHS[type] || Mystery;
  const scale = size / 48;
  return (
    <g transform={`translate(${x} ${y}) scale(${scale})`}>
      <Glyph />
    </g>
  );
}
